import { DialogService } from '@sdbn/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Station, TruckGroup, TruckGroupCondition, TruckGroupGateCondition } from '../../truck-group.model';
import { TruckGroupConditionSelectionComponent } from './truck-group-condition-selection/truck-group-condition-selection.component';

@Component({
    selector: 'app-truck-group-conditions',
    templateUrl: './truck-group-conditions.component.html',
    styleUrls: ['./truck-group-conditions.component.scss'],
    standalone: false
})
export class TruckGroupConditionsComponent implements OnInit {

  @Input() currentTruckGroup: TruckGroup;

  @Output() truckGroupChanged = new EventEmitter<boolean>();

  constructor(private dialogService: DialogService) { }

  ngOnInit() {
  }

  onAddHandle() {
    this.dialogService.openMaxHeight(TruckGroupConditionSelectionComponent, new TruckGroup(this.currentTruckGroup)).afterClosed().subscribe((result: { included: boolean, assignedStations: number[] } | null) => {
      if (result != null) {
        let truckGroupGateCondition: TruckGroupGateCondition;
        if (result.included) {
          truckGroupGateCondition = new TruckGroupGateCondition({
            inclusions: result.assignedStations,
          })
        } else {
          truckGroupGateCondition = new TruckGroupGateCondition({
            exclusions: result.assignedStations,
          })
        }
        this.currentTruckGroup.conditions.push(
          truckGroupGateCondition
        )

        this.truckGroupChanged.emit(true);
      }
    })
  }
  removeCondition(condition: TruckGroupGateCondition) {
    const index = this.currentTruckGroup.conditions.indexOf(condition);
    this.currentTruckGroup.conditions.splice(index, 1);
  }

}
